import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { isAutogeneratedBatchAnnotation } from 'features/kestrelViewer/utils/surfaceAreaBatchConfig'
import { useCallback } from 'react'
import { KVAnnotation } from 'types'

const DISTANCE_FROM_ANNOTATION = 26

export const useZoomToAnnotation = () => {
  const { sendKVCommand } = useKestrel()

  const zoomToAnnotation = useCallback(
    (annotation: KVAnnotation) => {
      if (!sendKVCommand) return

      if (annotation.geometry?.kind === 'point') {
        sendKVCommand({
          command: KestrelCommands.ZOOM_TO_LOCATION,
          annotationId: annotation.id,
          position: annotation.geometry.position,
          normal: annotation.geometry.normal,
        })
      } else if (annotation.geometry?.kind === 'polygon') {
        if (isAutogeneratedBatchAnnotation(annotation)) {
          if (annotation.centeredPosition && annotation.centeredNormal) {
            const adjustedPosition = {
              x:
                annotation.centeredPosition.x +
                annotation.centeredNormal.x * DISTANCE_FROM_ANNOTATION,
              y:
                annotation.centeredPosition.y +
                annotation.centeredNormal.y * DISTANCE_FROM_ANNOTATION,
              z:
                annotation.centeredPosition.z +
                annotation.centeredNormal.z * DISTANCE_FROM_ANNOTATION,
            }
            sendKVCommand({
              command: KestrelCommands.ZOOM_TO_LOCATION,
              surfaceAreaId: annotation.id,
              position: adjustedPosition,
              normal: annotation.centeredNormal,
            })
          }
        } else {
          sendKVCommand({
            command: KestrelCommands.ZOOM_TO_LOCATION,
            surfaceAreaId: annotation.id,
            position: annotation.centeredPosition,
            normal: annotation.centeredNormal,
          })
        }
      }
    },
    [sendKVCommand]
  )

  return { zoomToAnnotation }
}
